"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check if the user has the specified permission
 *
 * @param {AuthenticatedSession} session - Session object containing the user's permissions
 * @param {string|string[]} permissions - The requested permission(s), e.g. "opm:read"
 * @param {string} mode - "any" | "all" - When checking multiple permissions,
 *                        whether require just one or all of them
 */
exports.default = (session, permissions, mode = 'any') => {
    if (session.permissions) {
        permissions = permissions instanceof Array ? permissions : [permissions];
        return permissions[mode === 'any' ? 'some' : 'every'](p => session.permissions.includes(p));
    }
    return false;
};
//# sourceMappingURL=canDo.js.map